import React from "react";
import * as ReactIs from "react-is";
import { IRowPartProps, IColPartProps} from "../../models";
import { colCountToColWidth } from "../../models/utils";
import ColPart from "./ColPart";
import css from "../../form.module.scss";


const RowPart: React.FC<IRowPartProps> = ({ children, mobileCols, tabletCols, desktopCols } ) => {
  // Only render FormRow children.
  var cols = React.Children.map(children, c => {
    if (ReactIs.isElement(c) && c.type === ColPart)
      {
        const col = c as React.SFCElement<React.PropsWithChildren<IColPartProps>>;
        const {
          mobileWidth = colCountToColWidth(mobileCols),
          tabletWidth = colCountToColWidth(tabletCols),
          desktopWidth = colCountToColWidth(desktopCols)
        } = col.props;

        return (
          <ColPart
            {...col.props}
            mobileWidth={mobileWidth}
            tabletWidth={tabletWidth}
            desktopWidth={desktopWidth}
          />);
      }
    console.warn("`FormRow` contains children other than `FormCol`.  These will be ignored.");
    return null
  });

  return (
    <div className={`${css.formPart} columns is-multiline is-mobile`}>
      {cols}
    </div>
  );
}


export default RowPart;
